import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { Checkbox, Icon, Loader, Modal } from 'semantic-ui-react';
import Dropzone from 'react-dropzone';
import produce from 'immer';
import ImportedFileTag from '../OrderEntry/Documents/ImportedFileTag';
import { Property, FileUpload } from '../types';
import axios from 'axios';
import Button from '../../components/Button';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;
const Close = styled.button`
  display: flex;
  justify-content: flex-end;
  padding: 16px;
  background-color: #fff;
  border: none;
  cursor: pointer;
`;
const Header = styled.div`
  border-bottom: 1px solid #e5e5ea;
  padding: 0 24px 24px 24px;
  font-size: 16px;
  font-weight: bold;
`;
const Information = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 9px;
  margin-top: 56px;
  justify-content: flex-end;
  border-top: 1px solid #e5e5ea;
  padding: 24px 0;
`;

// const Button = styled.button`
//   background: #ffffff;
//   border: 1px solid #e5e5ea;
//   border-radius: 5px;
//   color: #444444;
//   font-weight: bold;
//   text-align: center;
//   height: 40px;
//   cursor: pointer;
//   padding: 10px;
// `;
const DocumentOptions = styled.div`
  border: 1.4px dashed #e5e5ea;
  padding: 24px;
  border-radius: 4px;
  margin: 0 24px;
`;
const UploadButton = styled.button`
  background-color: #333;
  border-radius: 5px;
  height: 40px;
  padding: 5px 16px;
  margin-right: 16px;
  border: none;
  width: 124px;
  font-weight: bold;
  cursor: pointer;
  color: #fff;
  :hover {
    background-color: #444;
  }
`;
interface Props {
  open: boolean;
  onClose: any;
  onDownload: () => void;
  otherSdaProperties: Property[];
  county: string;
  orderId: number;
  propertyId: number;
  getOrderDetails: () => void;
}

function convertToBase64(file: any) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result as string;
      const cleanedBase64 = result.substring(result.indexOf(',') + 1);
      resolve(cleanedBase64);
    };
    reader.onerror = error => {
      reject(error);
    };
  });
}

const UploadSdaModal = (props: Props) => {
  const [files, setFiles] = useState<FileUpload[]>([]);
  const [includeOtherPropertiesChecked, setIncludeOtherPropertiesChecked] = useState<boolean>(false);
  const [uploading, setUploading] = useState<boolean>(false);
  const [succesPopup, setSuccessPopup] = useState<boolean>(false);
  const [pdfErrorMessage, setPdfErrorMessage] = useState(false);

  useEffect(() => {
    const allFiles = files.every(f => {
      const extension = f.fileName?.substring(f.fileName?.lastIndexOf('.'));
      return extension === '.pdf';
    });
    setPdfErrorMessage(allFiles);
  }, [files]);

  const onDrop = async (newFiles: any) => {
    const arr: FileUpload[] = [];
    for (let file of newFiles) {
      const base64 = (await convertToBase64(file)) as string;
      const tempFile: FileUpload = {
        fileBase64: base64,
        fileName: file.name,
      };
      const extension = file?.name?.substring(file?.name?.lastIndexOf('.'));
      if (extension !== '.pdf') {
        setPdfErrorMessage(true);
      }
      arr.push(tempFile);
    }

    const newArray = produce(files, draft => {
      for (let file of arr) {
        draft.push(file);
      }
    });
    setFiles(newArray);
  };

  const onRemoveFileClick = (index: any) => {
    setFiles(files.filter((f, i) => i !== index));
  };
  const changeCustomFileName = (index: number) => (newName: string) => {
    const newFiles = produce(files, draft => {
      const fileName = draft[index].fileName;
      const extension = fileName.substring(fileName.lastIndexOf('.'));
      var startExtension = newName.lastIndexOf('.');
      const newExtension = newName.substring(startExtension);
      const removedExtensionFromName = startExtension > -1 ? newName.substring(0, startExtension) : newName;
      draft[index].fileName = `${removedExtensionFromName}${
        startExtension === -1 || newExtension.length > 5 ? extension : newExtension
      }`;
    });
    setFiles(newFiles);
  };
  const uploadSda = async () => {
    if (files.length === 0) {
      return;
    }
    setUploading(true);
    const sda = {
      files,
      county: props.county,
      orderId: props.orderId,
      includeAllProperties: includeOtherPropertiesChecked,
      propertyId: props.propertyId,
    };
    await axios.post(`/api/clientsearch/uploadSda`, sda);
    setSuccessPopup(true);
    setTimeout(() => {
      setSuccessPopup(false);
      props.onClose();
    }, 2000);
    setUploading(false);
   
    props.getOrderDetails();
  };
  return (
    <Modal open={props.open} style={{ width: 393, zIndex: 500, borderRadius: 5 }} onClose={props.onClose}>
      {succesPopup ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, padding:24 }}>
          Uploaded succesfully!
        </div>
      ) : (
        <ModalContent>
          <Close onClick={props.onClose}>
            <Icon name="close" />
          </Close>
          <Header>Upload SDA</Header>
          <Information>
            <Dropzone onDrop={onDrop}>
              {({ getRootProps, getInputProps, isDragActive }) => {
                return (
                  <DocumentOptions>
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <div style={{ textAlign: 'center' }}>
                        {isDragActive ? <span>drop here</span> : <span>Drag and drop files</span>}

                        <div style={{ color: '#e5e5ea', paddingTop: 8, paddingBottom: 8 }}>Or</div>
                        <UploadButton>Select File</UploadButton>
                      </div>
                    </div>
                  </DocumentOptions>
                );
              }}
            </Dropzone>
            {files.map((file, index) => {
              return (
                <div key={file.fileName} style={{ marginLeft: '-190px' }}>
                  <ImportedFileTag
                    fileNameToDisplay={file.fileName || file.fileName}
                    onRemoveClick={() => onRemoveFileClick(index)}
                    changeCustomFileName={changeCustomFileName(index)}
                  />
                </div>
              );
            })}
            {!pdfErrorMessage && (
              <div style={{ color: '#ff5252', fontSize: 12, marginLeft: 16, marginTop: 4 }}>
                The uploaded SDA should be in pdf format
              </div>
            )}
            {props.otherSdaProperties.length > 0 && (
              <div style={{ display: 'flex', alignItems: 'center', marginLeft: 24, marginTop: 16 }}>
                <Checkbox
                  onChange={(e, data) => setIncludeOtherPropertiesChecked(data.checked)}
                  checked={includeOtherPropertiesChecked}
                />
                <span style={{ marginLeft: 8 }}>Includes all properties</span>
              </div>
            )}
          </Information>
          <ButtonContainer>
            <Button
              onClick={props.onDownload}
              buttonType="ButtonSecondaryMedium"
              buttonText="Download SDA Form"
              width={150}
            >
              Download SDA Form
            </Button>
            <Button
              disabled={uploading || files.length === 0 || !pdfErrorMessage}
              onClick={uploadSda}
              style={{ marginRight: 24 }}
              buttonType={
                uploading || files.length === 0 || !pdfErrorMessage
                  ? 'ButtonSecondaryMediumDisabled'
                  : 'ButtonSecondaryMedium'
              }
              buttonText="Upload to Order"
            >
              Upload to Order
            </Button>
          </ButtonContainer>
        </ModalContent>
      )}
    </Modal>
  );
};

export default UploadSdaModal;
